import { errorValidation } from './utils';

let bulkPhone = $('#bulk_phone');

/**
 * Init intlTelInput
 */
[bulkPhone].forEach(phoneInput => {
	phoneInput.inputmask({
		mask: 'V9{1,15}',
		definitions: {
			V: {
				// validator: '^[1-9][0-9]*$',
				validator: '^[0-9]+$',
			},
		},
		placeholder: '',
	});

	// Set the initial country code on page load
	let initialCountryCode = phoneInput.intlTelInput(
		'getSelectedCountryData'
	).dialCode;
	let countryCodeInput = phoneInput
		.closest('.input-wrapper')
		.find('.country-code');
	countryCodeInput.val(initialCountryCode);

	// On blur: validate
	phoneInput.focusout(function () {
		if ($.trim(phoneInput.val())) {
			if (phoneInput.intlTelInput('isValidNumber')) {
				console.log('isValidNumber');
				// Save country code
				countryCodeInput.val(initialCountryCode);
			} else {
				phoneInput.addClass('_error');
			}
		}
	});

	// On keydown: reset
	phoneInput.keydown(function () {
		phoneInput.removeClass('_error');
	});
});

/**
 * Add custom validation method
 */
$.validator.addMethod(
	'validateBulkPhone',
	function () {
		if (bulkPhone.intlTelInput('isValidNumber')) {
			return true;
		} else {
			return false;
		}
	},
	window.translations.phoneInvalid
);

/**
 * Validate forms
 */
(() => {
	// Bulk
	$("form[name='bulk']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'bulk[name]': {
				required: true,
			},
			'bulk[city]': {
				required: true,
			},
			'bulk[email]': {
				required: true,
				email: true,
			},
			'bulk[phone]': {
				required: true,
				// validateBulkPhone: true,
			},
			'bulk[password]': {
				required: true,
			},
			'bulk[confirm_password]': {
				required: true,
				equalTo: '#password',
			},
			'bulk[privacy]': {
				required: true,
			},
		},
		messages: {
			'bulk[name]': {
				required: window.translations.required,
			},
			'bulk[city]': {
				required: window.translations.required,
			},
			'bulk[email]': {
				required: window.translations.required,
				email: window.translations.emailInvalid,
			},
			'bulk[phone]': {
				required: window.translations.required,
			},
			'bulk[password]': {
				required: window.translations.required,
			},
			'bulk[confirm_password]': {
				required: window.translations.required,
				equalTo: window.translations.equalTo,
			},
			'bulk[privacy]': {
				required: window.translations.checkboxRequired,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});

	$("form[name='bulk_logged']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'bulk_logged[privacy]': {
				required: true,
			},
		},
		messages: {
			'bulk_logged[privacy]': {
				required: window.translations.checkboxRequired,
			},
		},
		submitHandler: form => {
			form.submit();
		},
	});
})();
